import { keyframes } from "styled-components";

export const OSCILLATE = keyframes`
    0% {
    transform: translateX(0);
    }

    25% {
    transform: translateX(2px);
    }

    50% {
    transform: translateX(0);
    }

    75% {
    transform: translateX(-2px);
    }

    100% {
    transform: translateX(0);
    }
`;

export const SLIDE_STRIP = keyframes`
    0% {
        left: -100%;
    }
    100% {
        left: 100%;
    }
`;

export const SLIDE_UP = keyframes`
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    40% {
        transform: translateY(-40%);
        opacity: 0;
    }
    100% {
        transform: translateY(-100%);
        opacity: 0;
    }
`;

export const SLIDE_DOWN = keyframes`
    0% {
        transform: translateY(100%);
        opacity: 0.5;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
`;
